import { Injectable } from '@angular/core';
import { Constants } from '@constants/constants';
import { Observable, BehaviorSubject, Subscription, of } from 'rxjs';
import { CookieService } from '@services/cookie/cookie.service';
import { DsconfigService } from '@services/dsconfig/dsconfig.service';
import { StorageService } from '@services/storage/storage.service';
import { RestConnService } from '@services/rest-conn/rest-conn.service';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ROL_TYPE } from '@app/constants/enums';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable()
export class UserService {

  private userData: object;
  private refreshToken: object;
  private loginUser: object;
  private interval;
  private loginSessionInterval;
  private subscriptions: Array<Subscription> = [];
  public countDownSession: number = environment.sessionTime;
  public countDownLoginSession: number = environment.loginSessionTime;
  public countDownSession$ = new BehaviorSubject<number>(this.countDownSession);
  public countDownLoginSession$ = new BehaviorSubject<number>(this.countDownLoginSession);
  // expulsado por el sessionTimer
  public sessionExpired: any = [];
  public sessionExpired$ = new BehaviorSubject<any>(this.sessionExpired);

  constructor(
    private translate: TranslateService,
    private dsConfig: DsconfigService,
    private storage: StorageService,
    private _res: RestConnService,
    private router: Router,
    private cookie_service: CookieService,
    private modalService: NgbModal,
    private http: HttpClient
  ) {
    this.userData = {
      'user_data': dsConfig.getUrlBase() + '/ess/v1/user/info'
    };
    this.refreshToken = {
      'refresh_token': dsConfig.getUrlBase() + '/ess/v1/auth/refresh'
    };
    this.loginUser = {
      'loginUser': dsConfig.getUrlBase() + '/ess/v1/employee/validate' /** Poner aquí el nuevo endpoint */
    };
  }

  refreshCountDown() {
    clearInterval(this.interval);
    this.storage.set('countDownSession', environment.sessionTime);
    this.startCountDown(environment.sessionTime);
  }

  /**
   * Function to initialize the countdown login session time
   * This countdown controls the back token
   * @param countDown The countdown login session time
   */
  startLoginCountDown(countDown?: number): void {
    if (countDown) {
      this.countDownLoginSession = countDown;
    }
    this.loginSessionInterval = setInterval(() => {
      this.countDownLoginSession = this.countDownLoginSession - 1;
      this.countDownLoginSession$.next(this.countDownLoginSession);
      // guardamos la cuenta atras en el storage
      this.storage.set('countDownLoginSession', this.countDownLoginSession);
      // Automatic refresh login if user is active by countDownSession
      if (!this.countDownLoginSession) {
        if (this.countDownSession > environment.showSessionTimer) {
          this.refreshLoginToken();
        }
      }
    }, environment.delayTime);
  }

  /**
   * Function to initialize the countdown user session time
   * @param countDown The countdown user session time
   */
  startCountDown(countDown?: number) {
    if (countDown) {
      this.countDownSession = countDown;
    }
    this.interval = setInterval(() => {
      this.countDownSession = this.countDownSession - 1;
      this.countDownSession$.next(this.countDownSession);
      // guardamos la cuenta atras en el storage
      this.storage.set('countDownSession', this.countDownSession);
      if (!this.countDownSession) {
        this.logOut();
      }
    }, environment.delayTime);
  }

  isLogued(): boolean {

    //return this.cookie_service.check(Constants.UserData.TOKEN);
    let existeEmployeeNumber = this.storage.get("EMPLOYEE_NUMBER");
    return (existeEmployeeNumber != null);
  }

  logOut(): void {
    if (!this.countDownSession) {
      // expulsado por inactividad
      this.sessionExpired.message = this.translate.instant('SESSION_TIMER.EXPULSED_SESSION');
      this.sessionExpired.class = 'ForcedLogOutMessage bgf4';
      this.sessionExpired$.next(this.sessionExpired);
    } else {
      // msj de fin de session
      this.sessionExpired.message = this.translate.instant('SESSION_TIMER.LOGOUT');
      this.sessionExpired.class = 'LogOutMessage bgf4';
      this.sessionExpired$.next(this.sessionExpired);
    }

    this.modalService.dismissAll();
    clearInterval(this.interval);
    clearInterval(this.loginSessionInterval);
    this.storage.removeAll();
    this.cookie_service.delete(Constants.UserData.TOKEN);
    this.router.navigate(['/login']);
  }

  /** Método de login manual */

  manualLogin(data: any) {

    //console.log("VAMOS!!", data);
    //console.log(this.dsConfig.getUrlBase() + '/ess/v1/employee/validate');
    // return this._res
    //   .post('loginUser', data,
    //     {
    //       collection: this.loginUser
    //     }
    //   );

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post<any>(this.dsConfig.getUrlBase() + '/ess/v1/employee/validate', JSON.stringify(data), { headers });
    // const mockResponse = {
    //   "name": "Malásquez Sotelo, Pedro Manuel",
    //   "email": "pedro.malasquez@ciberexperis.es",
    //   "employeeNumber": 42,
    //   "profileId": 3
    // };
    // return of(mockResponse);
  }

  logIn(): void {
    // reinicio el msj de fin de session
    this.sessionExpired = '';
    this.sessionExpired$.next(this.sessionExpired);
    window.document.location.href = this.dsConfig.getUrlBase() + '/ess/v1/auth/login';
  }

  /**
   * Function to refresh the countdown user session and back token
   */
  refreshLogin(): Observable<any> {
    this.countDownSession = environment.sessionTime;
    this.countDownLoginSession = environment.loginSessionTime;
    return this._res.get('refresh_token', {}, { collection: this.refreshToken });
  }
  /**
   * Function to refresh the countdown login session and back token
   */
  refreshLoginToken(): Observable<any> {
    this.countDownLoginSession = environment.loginSessionTime;
    return this._res.get('refresh_token', {}, { collection: this.refreshToken }).subscribe((data) => {
      if (data.token) {
        this.storage.set(Constants.UserData.TOKEN, data.token);
      }
    });
  }

  setInit(): void {
    this.storage.set('appNavigation', true);
    this.storage.set(Constants.UserData.TOKEN, this.cookie_service.get(Constants.UserData.TOKEN));
  }

  getUserData(): Observable<any> {
    // return this._res.get('user_data', {},
    //   {
    //     collection: this.userData,
    //     cache: false,
    //     headers: {
    //       'Cache-Control': 'no-cache, no-store, max-age=0, must-revalidate',
    //       'Pragma': 'no-cache',
    //       'Expires': '0'
    //     }
    //   }
    // );

    // const mockResponse = {
    //   "name": "Malásquez Sotelo, Pedro Manuel",
    //   "email": "pedro.malasquez@ciberexperis.es",
    //   "employeeNumber": 42,
    //   "profileId": 3
    // };
    // return of(mockResponse);

    let params = new HttpParams()
    .set('name', this.storage.get('EMPLOYEE_NAME'))
    .set('email', this.storage.get('EMAIL'))
    .set('employeeNumber', this.storage.get('EMPLOYEE_NUMBER'))  // Convert number to string for query params
    .set('profileId', this.storage.get('PROFILE_ID'));

    return this.http.get<any>(this.dsConfig.getUrlBase() + '/ess/v1/user/info', { params });
  }

  /**
   * Function to check roltype of user
   * @param roltype
   * @returns A promise of observable
   */
  checkRolType(roltype: ROL_TYPE[]): any {
    return new Promise(resolve => {
      this.subscriptions.push(
        this.getUserData().subscribe((userData) => {
          if (userData) {
            if (roltype.includes(userData.profileId)) {
              resolve(of(true));
            } else {
              resolve(of(false));
            }
          }
        })
      );
    });
  }

  /** Funcion par abtener el lenguaje por default del navegador del usuario*/
  getDefaultLang(): any { }

  /**
   * función para setear un lenguaje determinado para un usuario
   */
  setOne(strin, lang): any { }

}
